<div class="page">
  @if (hidden) {
    <div class="card empty">
      <span class="empty__icon" aria-hidden="true"><span class="material-icons">assignment</span></span>
      <h1 class="empty__title">We're no longer recruiting for this project</h1>
      <p class="empty__text">This listing has been archived. Browse the Projects Board for current projects.</p>
      <a class="ut-btn ut-btn--secondary" uiSref="project">Projects Board</a>
    </div>
  } @else {
    <div>
      <div class="project__top">
        <a class="back-link" uiSref="project">
          <span class="material-icons" aria-hidden="true">arrow_back</span>
          Projects Board
        </a>
        <nav class="project__prevnext" aria-label="Previous and next project">
          @if (prev(); as item) {
            <a class="ut-btn ut-btn--secondary" uiSref="singleproject" aria-label="Previous project" [uiParams]="{ projectId: item.slug || item.id }" [attr.title]="item.title">
              <span class="material-icons" aria-hidden="true">chevron_left</span>
              <span class="project__prevnext-label">Previous</span>
            </a>
          } @else {
            <button type="button" class="ut-btn ut-btn--secondary" aria-label="Previous project" disabled>
              <span class="material-icons" aria-hidden="true">chevron_left</span>
              <span class="project__prevnext-label">Previous</span>
            </button>
          }
          @if (next(); as item) {
            <a class="ut-btn ut-btn--secondary" uiSref="singleproject" aria-label="Next project" [uiParams]="{ projectId: item.slug || item.id }" [attr.title]="item.title">
              <span class="project__prevnext-label">Next</span>
              <span class="material-icons" aria-hidden="true">chevron_right</span>
            </a>
          } @else {
            <button type="button" class="ut-btn ut-btn--secondary" aria-label="Next project" disabled>
              <span class="project__prevnext-label">Next</span>
              <span class="material-icons" aria-hidden="true">chevron_right</span>
            </button>
          }
        </nav>
      </div>
      @if (project.state === 'archived') {
        <div class="alert alert--warning project__archived" role="status">
          <span class="material-icons" aria-hidden="true">warning</span>
          <p class="alert__text">This project is archived. Only admins can see it.</p>
        </div>
      }
      <header class="card project__head">
        <div class="project__head-top">
        <div class="badges">
          @if (project.urgent) {
            <span class="badge badge--error">Urgent</span>
          } @else {
            <span class="badge">Ongoing</span>
          }
          @if (project.featured) {
            <span class="badge badge--brand"><span class="material-icons" aria-hidden="true">star</span>Featured</span>
          }
          @if (applied()) {
            <span class="badge badge--success"><span class="material-icons" aria-hidden="true">check</span>Applied</span>
          }
        </div>
        <ut-share-menu [url]="fullUrl" [text]="project.title"></ut-share-menu>
        </div>
        <h1 class="project__title">{{ project.title }}</h1>
        @if (project.start_date || project.countries?.length) {
          <div class="project__meta">
            @if (project.start_date) {
              <span><span class="material-icons" aria-hidden="true">event</span>Start date: {{ project.start_date | date: 'MMM dd' }}</span>
            }
            @if (project.countries?.length) {
              <span><span class="material-icons" aria-hidden="true">location_on</span><span class="sr-only">Countries: </span>{{ project.countries.join(', ') }}</span>
            }
          </div>
        }
      </header>
    </div>

    <div class="project__main">
      <section class="card" aria-labelledby="projectAbout">
        <h2 class="card__head" id="projectAbout">Description</h2>
        <div class="card__body prose" [innerHTML]="project.content"></div>
        <div class="card__body project__apply-area">
          <p class="project__note"><b>PLEASE NOTE: Due to the volume of submissions, you will only be contacted if you are invited to the project.</b></p>
          @if (!user) {
            <p class="project__note">Please <a class="a11y-link" [href]="loginUrl" target="_self">sign in</a> or <a class="a11y-link" uiSref="signup" target="_self">join uTest</a> today</p>
          } @else if (applied()) {
            @if (popupBlocked()) {
              <p class="project__error" role="alert" tabindex="-1">Your browser blocked the survey. Open it with the button below.</p>
            } @else if (project.survey_link) {
              <p class="project__note" tabindex="-1">You applied to this project. If the survey didn't open, or you didn't finish it, open it again.</p>
            } @else {
              <p class="project__note" tabindex="-1">You applied to this project.</p>
            }
            @if (project.survey_link) {
              <div>
                <button type="button" class="ut-btn ut-btn--secondary" (click)="openSurvey()">
                  Open the survey again
                  <span class="material-icons" aria-hidden="true">open_in_new</span>
                  <span class="sr-only">(opens in a new tab)</span>
                </button>
              </div>
            }
          } @else {
            @if (applyFailed()) {
              <p class="project__error" role="alert">We couldn't send your application, so the survey wasn't opened. Check your connection and try again.</p>
            }
            <div class="project__apply">
              <button type="button" class="ut-btn" aria-describedby="projectApplyNote" (click)="apply()">
                Apply
                <span class="sr-only">(opens the screening survey in a new tab)</span>
              </button>
              <span class="project__note" id="projectApplyNote">By selecting "Apply", I verify that I meet the requirements above</span>
            </div>
          }
        </div>
      </section>
    </div>
  }
</div>
